import * as React from 'react';
// @ts-expect-error
import type {ContextRouter, Match} from 'react-router-dom';

import type {User} from 'nutshell-core/users/users-types';

import {LeadPage as LeadPageDeprecated} from '../../ui/lead/deprecated/lead-page';
import {LeadPageM1} from '../../ui/lead/deprecated/lead-page-m1';
import {LeadPage} from '../../ui/lead/lead-page';

import {NoCrmAccessRedirect} from '../shared/crm-no-access-redirect';

type Props = ContextRouter & {
    user: User | null | undefined;
};

function formatLeadId(match: Match) {
    const leadId = match && match.params.leadId;

    if (typeof leadId !== 'string' || leadId === '') return undefined;

    return `${leadId}-leads`;
}

function formatLeadNum(match: Match) {
    const leadNum = match && match.params.leadNum;

    if (typeof leadNum !== 'string' || leadNum === '') return undefined;

    return Number(leadNum);
}

export function LeadPageRoot(props: Props) {
    // Get the lead number from the url, and turn it into an api-id.
    const leadNum = formatLeadNum(props.match);
    const leadId = formatLeadId(props.match);

    if (!leadNum && !leadId) {
        // TODO: handle this a bit more gracefully
        throw new Error('Cannot determine lead id');
    }

    if (!props.user) {
        return null;
    }

    if (!props.user.permissions.canAccessCrm) {
        return <NoCrmAccessRedirect />;
    }

    // If we've come here from another page, need to change the id on the body for styling
    const pageBody = document.querySelector('body');
    if (pageBody && pageBody.id !== 'lead') {
        pageBody.id = 'lead';
        pageBody.className = 'page leads';
    }

    if (NutClientConfig.hasLeadPageRedesignM3FF && props.user) {
        return (
            <LeadPage leadId={leadId} leadNum={leadNum} history={props.history} user={props.user} />
        );
    }

    if (NutClientConfig.hasLeadPageRedesignM1FF && props.user) {
        return (
            <LeadPageM1
                leadId={leadId}
                leadNum={leadNum}
                history={props.history}
                user={props.user}
            />
        );
    }

    return (
        <LeadPageDeprecated
            leadId={leadId}
            leadNum={leadNum}
            history={props.history}
            location={props.location}
        />
    );
}
